import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { appWindow, AppWindow } from '../AppWindow';
import { CoreModule } from '../core/core.module';

import { HasPermissionDirective } from './has-permission.directive';
import { PasswordRevealComponent } from './password-reveal/password-reveal.component';
import { SignedOutComponent } from './signed-out/signed-out.component';

@NgModule({
  declarations: [PasswordRevealComponent, HasPermissionDirective, SignedOutComponent],
  imports: [CommonModule, HttpClientModule, ReactiveFormsModule, CoreModule, RouterModule],
  exports: [HasPermissionDirective],
})
export class AuthorizationModule {
  // constructor(@Optional() @SkipSelf() parentModule?: AuthorizationModule) {
  //   if (parentModule) {
  //     throw new Error('AuthorizationModule is already loaded. Import it in the AppModule only');
  //   }
  // }
  /* Using forRoot() pattern to create singleton service for both eagerly and lazily loaded modules
   * Reference link: https://angular.io/guide/singleton-services#forroot-and-the-router */
  static forRoot(): ModuleWithProviders<AuthorizationModule> {
    return {
      ngModule: AuthorizationModule,
      providers: [
        // AuthorizationService
        {
          provide: AppWindow,
          useValue: appWindow,
        },
      ],
    };
  }
}
